import { installTranslationDomGuard } from "@helpers/translationDomGuard"
import * as Sentry from "@sentry/react"
import { PostHogProvider } from "posthog-js/react"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import { startWebConfidenceVisitorIdentitySync } from "./helpers/mergeWebConfidenceVisitorIdentity"
import "./i18n"
import "./index.css"

// Before React renders anything: see translationDomGuard.ts.
installTranslationDomGuard(undefined, (method) =>
  Sentry.addBreadcrumb({
    category: "translation-dom-guard",
    message: `Skipped a ${method} on a node changed by page translation`,
  }),
)

startWebConfidenceVisitorIdentitySync()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_API_KEY as string}
      options={{ api_host: import.meta.env.VITE_POSTHOG_API_HOST as string }}
    >
      <App />
    </PostHogProvider>
  </StrictMode>,
)
